import React from "react";

import { Container } from "../../components/Container";
import { Welcome } from "../../screens/Welcome";
import { InvalidLink } from "../../screens/InvalidLink";
import { Agreement } from "../../screens/Agreement";
import { Registration } from "../../screens/Registration";
import { Anthropometry } from "../../screens/Anthropometry";
import { Allergens } from "../../screens/Allergens";
import { RegistrationSuccess } from "../../screens/RegistrationSuccess";
import { Dietanamnez } from "../../screens/Dietanamnez";
import { DietanamnezTiles } from "../../screens/DietanamnezTiles";
import { Deficit } from "screens/Deficit";
import { Product } from "screens/Product";
import { Supplement } from "screens/Supplement";
import { Finish } from "../../screens/Finish";

import { StateManagerContext, useStateManager } from "utils/useStateManager";

import { UserType } from "types/UserType";

export const Root: React.FC<{}> = (props) => {
  const stateManager = useStateManager();
  const { userType, screen, linkInfo, onPrevScreen, onNextScreen } = stateManager;
  const isEpharmacy = userType === UserType.LITE && linkInfo?.custom?.custom_генерировать_бад_рацион_при_саморегистрации;
  const showProducts = userType === UserType.LITE && linkInfo?.custom?.custom_показывать_экран_рекомендуемая_продукция;
  const miratorgData = userType === UserType.LITE ? linkInfo?.custom?.custom_additional_data?.final_screen_additional_content : undefined;

  if (!screen) {
    return null;
  }

  const screensList = isEpharmacy ?
    {
      ERROR: <InvalidLink userType={userType} />,
      WELCOME: <Welcome onSubmit={onNextScreen} />,
      REGISTRATION_SUCCESS: <RegistrationSuccess onSubmit={onNextScreen} />,
      DIETANAMNEZ: <Dietanamnez onBack={onPrevScreen} onSubmit={onNextScreen} />,
      DIETANAMNEZ_TILES: (
        <DietanamnezTiles onBack={onPrevScreen} onSubmit={onNextScreen} />
      ),
      REGISTRATION: <Registration onSubmit={onNextScreen} />,
      DEFICIT: <Deficit onSubmit={onNextScreen} />,
      PRODUCT: <Product onSubmit={onNextScreen} showProducts={showProducts} miratorgData={miratorgData}/>,
    } :
    {
      ERROR: <InvalidLink userType={userType} />,
      WELCOME: <Welcome onSubmit={onNextScreen} />,
      REGISTRATION_SUCCESS: <RegistrationSuccess onSubmit={onNextScreen} />,
      DIETANAMNEZ: <Dietanamnez onBack={onPrevScreen} onSubmit={onNextScreen} />,
      DIETANAMNEZ_TILES: (
        <DietanamnezTiles onBack={onPrevScreen} onSubmit={onNextScreen} />
      ),
      ALLERGENS: <Allergens onBack={onPrevScreen} onSubmit={onNextScreen} />,
      AGREEMENT: <Agreement onSubmit={onNextScreen} />,
      REGISTRATION: <Registration onSubmit={onNextScreen} />,
      ANTHROPOMETRY: (
        <Anthropometry onBack={onPrevScreen} onSubmit={onNextScreen} />
      ),
      SUPPLEMENT: <Supplement onBack={onPrevScreen} onSubmit={onNextScreen} />,
      FINISH: <Finish />,
    };

  return (
    <StateManagerContext.Provider value={stateManager}>
      <Container>{screensList[screen!]}</Container>
    </StateManagerContext.Provider>
  );
};
